import Header from './Header';
import Sidebar from './Sidebar';
import './Layout.css';

type LayoutProps = {
  children: React.ReactNode;
};

const Layout: React.FC<LayoutProps> = ({ children }) => {
  return (
    <div className='layout'>
      <Sidebar />
      <div className='layout-main'>
        <Header />
        <main className='main-content'>
          {children}
        </main>
      </div>
    </div>
  );
};

export default Layout;
